import BaseRequest, { IPagination } from './BaseRequest';

export interface IResponseSuccess<T> {
  data: T[];
  meta: {
    count: number;
  };
}

export default class CommunityRequest extends BaseRequest {
  getCommunities(payload: IPagination) {
    const url = `/community`;
    return this.get(url, payload);
  }

  getAllCommunity() {
    const url = `/community/all`;
    return this.get(url);
  }

  createCommunity(payload: { name: string }) {
    const url = `/community`;
    return this.post(url, payload);
  }

  updateCommunity(id: number, payload: { name: string }) {
    const url = `/community/${id}`;
    return this.patch(url, payload);
  }
  deleteCommunity(id: number) {
    const url = `/community/${id}`;
    return this.delete(url);
  }
}
